import React from 'react';
import { useNavigate } from 'react-router-dom';

function PaymentSuccess() {
    const navigate = useNavigate();
    const handleNavigate = () => {
navigate('/')
    }
  return (
    <div style={styles.container}>
      <img 
        src="./PaymentSuccess.svg" 
        alt="Payment Successful" 
        style={styles.image} 
      />
      <h1 style={styles.heading}>Payment Successful</h1>
      <p style={styles.message}>
        Thank you for your payment! Your transaction has been completed successfully.
      </p>
      <button style={styles.button} onClick={() => handleNavigate()}>
        Go to Home
      </button>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    textAlign: 'center',
  },
  image: {
    width: '50%',
    height: 'auto', 
    marginBottom: '20px',
  },
  heading: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#4caf50',
    marginBottom: '10px',
  },
  message: {
    fontSize: '16px',
    color: '#555',
    textAlign: 'center',
    maxWidth: '400px',
    marginBottom: '20px',
  },
  button: {
    backgroundColor: '#4caf50',
    color: '#fff',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '16px',
  },
};

export default PaymentSuccess;
